import { apiHelper, sharedHelper } from '@/utils'
import { API } from '@/constants'

export const labelService = {
  getAllLabels,
  updateLabelStatus,
  getLabel,
  updateLabel,
  createLabel,
  createLabelMultiple
};

const MODULE = {
  label: 'rnd-product-labels',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'label') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllLabels(filter) {

  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
      product: filter.product,
      name: filter.name,
      package_size: filter.packageSize,
      is_active: filter.isActive
    }
  }

  let array = filter.searchArray
  array.forEach((word, index) => {
    if (word != null || word != '') {
      var searchParam = `search_words[${index}]`
      requestOptions.params[searchParam] = word
    }
  })

  return await apiHelper(API_URL).get(`/${MODULE.label}`, requestOptions)
}


export function updateLabelStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.label}/${data.id}`, requestOptions)
}

export function getLabel(id) {
  return apiHelper(API_URL).get(`/${MODULE.label}/${id}`)
}

export function updateLabel(data) {
  const formData = new FormData();
  formData.append(`product_uuid`, data.productID);
  formData.append(`name`, data.name);
  if(data.sizes && data.sizes.length > 0) {
        data.sizes.forEach((size, index) => {
            formData.append(`sizes[${index}]`, size);
        });
  }
  formData.append(`date`, data.date);
  formData.append(`packaging_material`, data.packagingMaterial);
  sharedHelper.appendIfNotNullArray(formData, 'file_deleted', data.removedFile);
  formData.append('_method', "put");

  if (data.files != null) {
    data.files.forEach((file, index) => {
      if (file instanceof File) {
        formData.append(`files[${index}]`, file);
      } else {
        console.warn(`Image at index ${index} is not a File object`);
      }
    });
  }

  if (data.image instanceof File) {
    formData.append(`image`, data.image);
  }

  if (data.imageBack instanceof File) {
    formData.append(`image_back`, data.imageBack);
  }

  return apiHelper(API_URL).post(`/${MODULE.label}/${data.id}`, formData)
}

export function createLabel(data) {
  const formData = new FormData();
  formData.append(`product_uuid`, data.productID);
  formData.append(`name`, data.name);
  formData.append(`date`, data.date);
  formData.append(`packaging_material`, data.packagingMaterial);
  if(data.sizes && data.sizes.length > 0) {
        data.sizes.forEach((size, index) => {
            formData.append(`sizes[${index}]`, size);
        });
  }
  if (data.files != null) {
    data.files.forEach((file, index) => {
      if (file instanceof File) {
        formData.append(`files[${index}]`, file);
      } else {
        console.warn(`Image at index ${index} is not a File object`);
      }
    });
  }

  if (data.image instanceof File) {
    formData.append(`image`, data.image);
  }

  if (data.imageBack instanceof File) {
    formData.append(`image_back`, data.imageBack);
  }

  return apiHelper(API_URL).post(`/${MODULE.label}`, formData)
}

export function createLabelMultiple(data) {
  const formData = new FormData();
  const labels = data.labels
    .filter(item => item.labels) // remove empty ones
    .map(item => ({
      name: item.name.trim(),
      sizes: item.sizes,
      date: item.date,
      packaging_material: item.packagingMaterial,
    }))

  formData.append(`product_uuid`, data.productID);
  formData.append(`labels`, labels);

  return apiHelper(API_URL).post(`/${MODULE.label}`, formData)
}